// Unpublished Work © 2023 Deere & Company.
import { PricingDetailsResponse } from "../../pages/parts/PartInfo/types";
import axios from "../api";
import {
  ConsolidatedPriceResponse,
  OrderPriceRequest,
  PricingPayload,
  PricingWithTaxDetails,
  PricingWithTaxDetailsRequest,
} from "./pricingInterfaces";

const pricingApi = {
  getPricing: (
    pricingServiceUrl: string,
    accountId: string,
    partNumber: string,
    token: string
  ): Promise<PricingDetailsResponse> =>
    axios
      .getWithRetries(`${pricingServiceUrl}/pricing/v1/search`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          accountId,
          partNumber,
        },
      })
      .then((response) => response.data),

  getPricings: (
    pricingServiceUrl: string,
    payload: PricingPayload,
    token: string
  ): Promise<PricingDetailsResponse[]> =>
    axios
      .postWithRetries(`${pricingServiceUrl}/pricing/v1/search`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data),

  getLinePriceDetails: (
    pricingRequest: PricingWithTaxDetailsRequest,
    pricingServiceUrl: string,
    accessToken: string
  ): Promise<PricingWithTaxDetails> =>
    axios
      .postWithRetries(
        `${pricingServiceUrl}/pricing/v1/line-price`,
        {
          ...pricingRequest,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((response: any) => response.data),

  getConsolidatedPriceDetails: (
    consolidatedPriceRequest: PricingWithTaxDetailsRequest[],
    pricingServiceUrl: string,
    accessToken: string
  ): Promise<ConsolidatedPriceResponse> =>
    axios
      .postWithRetries(
        `${pricingServiceUrl}/pricing/v1/consolidated-items-prices`,
        consolidatedPriceRequest,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((response: any) => response.data),
  getOrderPriceDetails: (
    orderPriceRequests: OrderPriceRequest,
    pricingServiceUrl: string,
    accessToken: string
  ): Promise<ConsolidatedPriceResponse> =>
    axios
      .postWithRetries(
        `${pricingServiceUrl}/pricing/v1/order-header-prices`,
        orderPriceRequests,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((response: any) => response.data),
};

export default pricingApi;
